/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


const isCartEnabled = window.shopifySettings?.tieredProgressBar === "on"; 

function addProgressBar() {
  if (!isCartEnabled) return;

  const cartElement = document.querySelector('.rebuy-cart__flyout-header');
  if (!cartElement) return;

  const existingProgressBar = document.querySelector('#progress-bar-container');
  if (existingProgressBar) return;

  const progressBarHTML = `
    <div id="progress-bar-container" style="padding: 10px; background: #f9f9f9; position: relative;">
      <div id="tier-labels" style="position: relative; margin-bottom: 5px; height: 20px;">
        <span class="tier-label" data-tier="75" style="position: absolute; transform: translateX(-50%); font-size: 12px;">$75</span>
        <span class="tier-label" data-tier="125" style="position: absolute; transform: translateX(-50%); font-size: 12px;">$125</span>
        <span class="tier-label" data-tier="200" style="position: absolute; transform: translateX(-50%); font-size: 12px;">$200</span>
      </div>
      <div id="progress-bar" style="background: #e0e0e0; border-radius: 8px; height: 10px; width: 100%; position: relative;">
        <div id="progress-bar-fill" style="background: #FDB828; height: 100%; width: 0%; border-radius: 8px;"></div>
      </div>
      <div id="progress-bar-label" style="margin-top: 5px; text-align: center; font-size: 14px;">
        Add $XX more to unlock next offer!
      </div>
    </div>
  `;

  cartElement.insertAdjacentHTML('afterend', progressBarHTML);

  updateTierLabels();

  updateProgressBar();
}

function updateTierLabels() {
  const tiers = [75, 125, 200]; 
  const maxTier = 200; 

  tiers.forEach((tier) => {
    const label = document.querySelector(`.tier-label[data-tier="${tier}"]`);
    if (label) {
      const leftPosition = (tier / maxTier) * 100;
      console.log(leftPosition)
      label.style.left = `${Math.max(leftPosition === 100 ? 95 : leftPosition)}%`;
    }
  });
}

function updateProgressBar() {
  if (!isCartEnabled) return; 

  const cartSubtotalElement = document.querySelector('.rebuy-cart__flyout-subtotal-amount');
  if (!cartSubtotalElement) return;

  const tier1 = 75; 
  const tier2 = 125; 
  const tier3 = 200;

  const GIFT_VARIANT_ID = 41932100173872;

  const validSubtotal = Rebuy.Cart.cart.items
  .filter(item => 
    !(item.tags || []).includes('IMAP') &&
    item.variant_id !== GIFT_VARIANT_ID
  )
  .reduce((sum, item) => sum + item.original_price * item.quantity, 0) / 100;

  let progressPercentage = Math.min((validSubtotal / tier3) * 100, 100);

  const progressBarFill = document.getElementById('progress-bar-fill');
  const progressBarLabel = document.getElementById('progress-bar-label');

  progressBarFill.style.width = `${progressPercentage}%`;

  if (validSubtotal < tier1) {
    const remaining = (tier1 - validSubtotal).toFixed(2);
    progressBarLabel.textContent = `Add $${remaining} more to unlock 15% discount and free shipping!`;
  } else if (validSubtotal < tier2) {
    const remaining = (tier2 - validSubtotal).toFixed(2);
    progressBarLabel.textContent = `Add $${remaining} more to unlock 20% discount!`;
  } else if (validSubtotal < tier3) {
    const remaining = (tier3 - validSubtotal).toFixed(2);
    progressBarLabel.textContent = `Add $${remaining} more to unlock 25% discount!`;
  } else {
    progressBarLabel.textContent = "You’ve unlocked the maximum discount!";
  }
}



// GIFT PROGRESS BAR - JCE2
function addGiftProgressBar() {
  const cartElement = document.querySelector('.rebuy-cart__flyout-header');
  if (!cartElement || document.querySelector('#gift-progress-bar-container')) return;

  const giftProgressHTML = `
    <div id="gift-progress-bar-container" style="padding: 10px; background: #eef7ff; position: relative;">
      <div style="background: #cde3f9; border-radius: 8px; height: 10px; width: 100%; position: relative;">
        <div id="gift-progress-fill" style="background: #1e90ff; height: 100%; width: 0%; border-radius: 8px;"></div>
      </div>
      <div id="gift-progress-label" style="margin-top: 5px; text-align: center; font-size: 14px;">
        Spend $75 to get a free Tumbler!
      </div>
    </div>
  `;

  cartElement.insertAdjacentHTML('afterend', giftProgressHTML);
  updateGiftProgressBar();
}

function updateGiftProgressBar() {
  const giftThreshold = 75;
  const GIFT_VARIANT_ID = 41932100173872;

  const validSubtotal = Rebuy.Cart.cart.items
    .filter(item => 
      !(item.tags || []).includes('IMAP') &&
      item.variant_id !== GIFT_VARIANT_ID
    )
    .reduce((sum, item) => sum + item.original_price * item.quantity, 0) / 100;
  

  const percentage = Math.min((validSubtotal / giftThreshold) * 100, 100);
  const fill = document.getElementById('gift-progress-fill');
  const label = document.getElementById('gift-progress-label');

  if (fill) fill.style.width = `${percentage}%`;

  if (label) {
    if (validSubtotal >= giftThreshold) {
      label.textContent = "🎁 You've earned a free Tumbler!";
      renderGiftTumbler();
    } else {
      const remaining = (giftThreshold - validSubtotal).toFixed(2);
      label.textContent = `Spend $${remaining} more to get a free Tumbler!`;

      const giftItem = Rebuy.Cart.cart.items.find(item => item.variant_id === GIFT_VARIANT_ID);
      if (giftItem) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftItem.key, quantity: 0 })
        }).then(() => {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      }

      removeGiftTumbler(); 
    }
  }
}


function renderGiftTumbler() {
  const itemList = document.querySelector('[data-smartcart-items]');
  if (!itemList || document.getElementById('free-gift-tumbler')) return;

  const alreadyHasGift = Rebuy.Cart.cart.items.some(item => item.variant_id === 41451050893360);
  if (alreadyHasGift) return;

  const tumblerHTML = `
    <li id="free-gift-tumbler" class="rebuy-cart__flyout-item" style="opacity: 0.8;">
      <div class="rebuy-cart__flyout-item-media">
        <img src="https://cdn.shopify.com/s/files/1/0256/0412/8816/files/Copy_of_Rose_Gold_Wine_Tumbler_-_Primary_-_TF1140.png?v=1743025470" alt="Free Gift Tumbler">
      </div>
      <div class="rebuy-cart__flyout-item-info">
        <div class="rebuy-cart__flyout-item-product-title" style="font-weight: bold;">🎁 Free Gift: Toadfish Wine Tumbler – $25 will be deducted at checkout</div>
        <button id="add-gift-to-cart-btn" style="display: none;">Add to cart</button>
      </div>
    </li>
  `;
  itemList.insertAdjacentHTML('beforeend', tumblerHTML);

  const GIFT_VARIANT_ID = 41932100173872;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
  })
    .then(res => {
      if (!res.ok) throw new Error('Gift add failed');
      return res.json();
    })
    .then(data => {
      console.log('✅ Gift added:', data);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      hidePaidTumblerUI();
    })
    .catch(err => {
      console.error('🚨 Error adding gift:', err);
    });

    hidePaidTumblerUI();
}

function enforceSingleGiftTumbler() {
  const GIFT_VARIANT_ID = 41932100173872;

  const giftItem = Rebuy.Cart.cart.items.find(item => item.variant_id === GIFT_VARIANT_ID);

  if (giftItem && giftItem.quantity > 1) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: giftItem.key, quantity: 1 })
    }).then(() => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  }
}


function removeGiftTumbler() {
  const giftItem = document.getElementById('free-gift-tumbler');
  if (giftItem) giftItem.remove();
}



// cart change catch
const observer = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (mutation.addedNodes) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList.contains('rebuy-cart')) {
          addProgressBar();
          addGiftProgressBar();
        }
      });
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });

function hidePaidTumblerUI() {
  const allItems = document.querySelectorAll('.rebuy-cart__flyout-item');

  allItems.forEach(item => {
    const titleEl = item.querySelector('.rebuy-cart__flyout-item-product-title');
    const titleText = titleEl?.textContent?.trim() || '';

    if (titleText === 'Toadfish Non-tipping Wine Tumbler') {
      item.style.display = 'none';
    }
  });
}

document.addEventListener('rebuy:cart.change', () => {
  updateProgressBar();
  updateTierLabels();
  updateGiftProgressBar();
  enforceSingleGiftTumbler();
  hidePaidTumblerUI();
});
